import ApiService from "@/common/services/http/api.service";

const FechamentoMesService = {
  async get(params = null) {
    const { data: result } = await ApiService.get("FechamentoMes", "", params);
    return result;
  },
};

export default FechamentoMesService;
